import React from "react";
import {domain} from "../../../Auth/Config"
const withdrawRequestUrl = domain + "/wp-json/freespin/v1/withdraw";
const withdrawCommentsListUrl = domain + "/wp-json/freespin/v1/withdrawcomments";
const isWithdrawAvailableEndpoint = domain + "/wp-json/freespin/v1/isWithdrawalAvailable";
const getUserApiService = "https://api.ipify.org?format=json";
export {withdrawRequestUrl, withdrawCommentsListUrl, isWithdrawAvailableEndpoint, getUserApiService};
